export default {
  id: "recentSales",
  name: "",
  description: "",
  report: {
    name: "Recent Sales",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: ["Sale.sale_stamp", "Sale.sale_time"],
      measures: ["Sale.total_revenue", "Sale.units_sold"],
      sort: {
        direction: "desc",
        by: "Sale.sale_time",
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
